import CryptoJS from 'crypto-js'

var key = CryptoJS.enc.Utf8.parse('748521560af141f7ab458a6cc98d89f4')
var iv = CryptoJS.enc.Utf8.parse('4516a117b5ac9d94')
export default function encrypt_str(phone) {
  return CryptoJS.AES.encrypt(phone, key, { iv: iv }).toString()
}
